<template>
	<div class="operation-add-substract-fractions-component">
		<div class="operation-add-substract-fractions">
			<div class="operation-terms mt-4">
				<template v-if="mixed">
					<span :is="mixed_terms"></span>
					<span>=</span>
					<!-- <equal-sign></equal-sign> -->
					<template v-if="strict_mixed">
						<span :is="mixed_to_fractions_terms"></span>
						<!-- <equal-sign></equal-sign> -->
						<span>=</span>
					</template>
				</template>
				<component class="fractions-term" :is="terms_fractions" />
				<template v-if="simplificated_terms">
					<span>=</span>
					<component :is="simplificated_terms" class="simplificated-terms" />
				</template>
				<!-- <equal-sign>=</equal-sign> -->
				<span>=</span>
				<span :is="extras"></span>
				<span>=</span>
				<!-- <equal-sign></equal-sign> -->

				<template v-if="!result.isSimplificated">
					<fraction-component :fraction="result"></fraction-component>
					<!-- <equal-sign></equal-sign> -->
					<span>=</span>
					<!-- <span :is="result_simplification"></span> -->
					<fraction-component :fraction="result.simplification"></fraction-component>
					<span>=</span>
				</template>

				<fraction-component :fraction="result.simplificated" class="result"></fraction-component>

				<template v-if="result.intVal>=1">
					<!-- <equal-sign></equal-sign> -->
					<span>=</span>
					<span :is="intFractionNotation"> </span>
				</template>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Fraction from '../scripts/Fraction';
	import FractionComponent from '../FractionComponent.vue';
	import EqualSign from '../FractionComponent.vue';
	const $operations = require('../scripts/variables').operations;
	const $operators = require('../scripts/variables').operators;
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';

	export default {
		name: 'AddSubtractFractions',
		components: { FractionComponent, EqualSign},
		mixins: [BaseExerciseMixin],
		props: {
			operator: { type: String, required: false, default: '+' },
			terms: { type: [Array], required: true },
		},
		data(){
			return {
				is_reducing: false,
				fractions: [],
				good_terms: this.terms.map(el => new Fraction(el)),
				op: $operators.checkOp_plus(this.operator) ? ' + ':' - ',
			};
		},
		created(){
			this.lcm = this.ppcm(this.good_terms.map(el => el.den));

			let terms = this.terms.map(el => new Fraction(el)), terms_ppcm = this.lcm, terms_den = terms.map(el => el.den);
			this.is_reducing =! terms_den.map(el => el == terms_ppcm).reduce((a, b) => a && b, true);
			this.result = $operations.additionFract(this.operator, this.terms);
			this.mixed = terms.map(el => el.intVal >= 1).reduce((a, b) => a || b, false);
			this.fractions = this.mixed ? terms.map(el => new Fraction(el.simplificated)) : terms;
		},
		methods: {},
		computed: {
			strict_mixed() {
				let terms = this.terms.map(el => new Fraction(el));
				return !this.fractions.map((fr, i) => fr.num == terms[i].num).reduce((a, b) => a && b);
			},
			terms_fractions() {
				let first_fraction = this.fractions.filter(term => term.intVal != term.simplificated).pop(),
					terms = this.fractions.map(term => {
					if (term.intVal == term.simplificated) {
						return new Fraction({num: term.simplificated, den: 1}).toString();
					}
					return new Fraction(term.simplificated).toString()
				});
				return {
					template: this.tag('span', this.fractions.join(this.tag('span', this.operator, { class: 'add-operator mx-1'}))),
					components: { FractionComponent },
					name: 'TermsFractions'
				}
			},
			extras(){
				return {
					template: this.tag('span', this.result.extras.map(el => new Fraction(el)).join(this.tag('span', ' = '))),
					components: {FractionComponent, EqualSign},
					name: 'Extras'
				};
			},
			simplificated_terms() {
				if(this.fractions.every((term, i) => term.isSimplificated)) {
					return null;
				}
				let first_fraction = this.fractions.filter(term => term.intVal != term.simplificated).pop(),
					terms = this.fractions.map(term => {
					if (term.intVal == term.simplificated) {
						return new Fraction({num: term.simplificated, den: 1}).toString();
					}
					return new Fraction(term.simplificated).toString()
				});
				return {
					template: this.tag('span', terms.join(this.tag('span', this.operator, { class: 'add-operator mx-1'}))),
					components: { FractionComponent },
					name: 'SimplificatedTerms'
				}
			},
			mixed_terms(){
				return{
					template: this.tag('span', this.fractions.map(el => el.intVal >= 1 ? el.intFractionNotation : el).join(this.op)),
					components: { FractionComponent },
					name: 'MixedTerms'
				}
			},
			mixed_to_fractions_terms(){
				return {
					template: this.tag('span', this.fractions.map(el => el.mixed_to_fraction_operation).join(this.op)),
					components: { FractionComponent },
					name: "MixedToFraction"
				};
			},
			result_simplification(){
				return {
					template: this.result.simplification,
					components: { FractionComponent },
					name: 'ResultSimplification'
				}
			},
			intFractionNotation(){
				return {
					template: '<span>'+ this.tag('span', this.result.intFractionNotation) + '</span>',
					components: { FractionComponent }
				}
			}
		}
	};
</script>